import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  @Input() selectedSection: string;

  sections: any[] = [
    {label: 'What is opioid dependence?', link: 'what'},
    {label: 'How is opioid dependence treated?', link: 'treatment'},
    {label: 'Do I have opioid dependence?', link: 'questionnaire'},
    {label: 'How can I get help?', link: 'referral'}
  ]
}
